import * as React from "react";
const SvgPandaDoc = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#248567",
  d: "M0 0h30v30H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m22 10.99-.08.04c-.64-.53-1.47-.87-2.53-.87-1.36 0-2.61.49-3.44 1.48l1.29 1.37c.64-.61 1.32-.95 2.19-.95 1.63.04 2.68 1.29 2.68 2.97S21.01 18 19.35 18c-4.16 0-2.99-7.83-8.58-7.83-2.8 0-4.76 2.09-4.76 4.87v8.48h2v-4.53l.08-.04c.64.53 1.47.87 2.53.87 1.36 0 2.61-.49 3.44-1.48l-1.29-1.37c-.64.61-1.32.95-2.19.95-1.63-.04-2.68-1.29-2.68-2.97s1.1-2.97 2.76-2.97c4.16 0 2.99 7.83 8.58 7.83 2.8 0 4.76-2.09 4.76-4.87V6.5h-2z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.97 2.34h.69c.23 0 .41.05.55.14q.21.15.21.45 0 .24-.12.36c-.07.08-.17.14-.29.18l.52.84h-.45l-.48-.77h-.21v.77h-.43V2.33zm.68.91c.23 0 .34-.1.34-.29 0-.11-.03-.18-.09-.23a.44.44 0 0 0-.25-.06h-.25v.58zm0 1.77c.23 0 .45-.04.65-.12a1.58 1.58 0 0 0 .86-.87c.08-.21.13-.43.13-.68s-.04-.47-.13-.68c-.08-.21-.19-.38-.33-.52-.14-.15-.32-.27-.52-.34a1.76 1.76 0 0 0-1.33 0c-.2.08-.37.19-.51.34s-.26.33-.34.53c-.08.21-.12.43-.12.68s.04.47.13.68c.08.21.2.38.34.52.15.14.32.26.52.34s.42.12.65.12m0 .33q-.42 0-.78-.15t-.63-.42c-.18-.18-.32-.39-.43-.63-.1-.24-.15-.5-.15-.79s.05-.54.15-.78c.1-.25.24-.46.42-.64s.39-.32.63-.43c.25-.11.51-.16.79-.16q.42 0 .78.15c.25.1.46.24.64.43.37.38.575.89.57 1.42 0 .28-.05.55-.16.8q-.15.36-.42.63c-.18.17-.39.31-.64.42-.24.1-.5.15-.77.15"
}));
export default SvgPandaDoc;
//# sourceMappingURL=PandaDoc.js.map